import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const routeNameMap: Record<string, string> = {
  '': '首页',
  category: '分类浏览',
  article: '文章详情',
  about: '关于我们',
  latest: '最新内容',
  exclusive: '独家资源',
  featured: '精品推荐',
  popular: '热门排行',
  members: '会员专区',
};

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  if (!items || items.length === 0) {
    const pathParts = location.pathname.split('/').filter(Boolean);
    items = [{ label: '首页', href: '/' }];
    let currentPath = '';
    pathParts.forEach((part) => {
      currentPath += `/${part}`;
      const label = routeNameMap[part] || part;
      items.push({ label, href: currentPath });
    });
  }

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://mitaomedia.com${item.href}` : undefined,
    })),
  };

  return (
    <>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3 px-4 md:px-6">
        <ol className="flex items-center flex-wrap gap-1">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-300" aria-hidden="true">/</span>
              )}
              {item.href && index < items.length - 1 ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        data-dynamic-schema="true"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd, null, 2) }}
      />
    </>
  );
}